package com.anjuros.website.templates.template4.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Template4Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#f37f34", rgb = rgb(r = 31, g = 178, b = 230)),
    OpacityPrimary(hex = "#00A78E", rgb = argb(a=0.8f,r = 31, g = 178, b = 230)),
    Secondary(hex = "#121D34", rgb = rgb(r = 18, g = 29, b = 52)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
}

@Composable
fun Template4Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template4Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}